module.exports = __webpack_public_path__ + "static/img/1432121.0341a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/1432121.png
// module id = d72C
// module chunks = 0